// extracted by mini-css-extract-plugin
module.exports = {"youSaveWrapper":"styles_youSaveWrapper__rMV4j","bigBonusWrapper":"styles_bigBonusWrapper__qPYYo"};